import {
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    Unsubscribe,
    collection,
    collectionGroup,
    limit as fLimit,
    orderBy as fOrderBy,
    query as fQuery,
    startAfter as fStartAfter,
    where as fWhere,
    getDocs,
    onSnapshot,
} from 'firebase/firestore'

import { firestore } from './firebase.ts'
import { FSDocument } from './types.ts'

export interface GetCollectionParams {
    path: string
    orderBy?: Parameters<typeof fOrderBy>
    limit?: number
    startAfter?: number
    where?: Parameters<typeof fWhere>[]
    converter?: FirestoreDataConverter<any, any>
    isCollectionGroup?: boolean
}

export const listenCollection = async <T extends FSDocument>(
    { path, orderBy, limit, startAfter, where, converter, isCollectionGroup }: GetCollectionParams,
    onCollectionChange: (docs: QueryDocumentSnapshot<T>[]) => void,
): Promise<Unsubscribe> => {
    const collectionFn = isCollectionGroup ? collectionGroup : collection
    const ref = converter ? collectionFn(firestore, path).withConverter(converter) : collectionFn(firestore, path)

    const query = fQuery(
        ref,
        ...[
            ...(where ? where.map(w => fWhere(...w)) : []),
            ...(orderBy ? [fOrderBy(...orderBy)] : []),
            ...(limit ? [fLimit(limit)] : []),
            ...(startAfter ? [fStartAfter(startAfter)] : []),
        ],
    )

    return onSnapshot(query, snapshot => {
        const docs = snapshot.docs
        onCollectionChange(docs)
    })
}

export const getCollection = async <T extends FSDocument>({
    path,
    orderBy,
    limit,
    startAfter,
    where,
    converter,
    isCollectionGroup,
}: GetCollectionParams): Promise<QueryDocumentSnapshot<T>[]> => {
    const collectionFn = isCollectionGroup ? collectionGroup : collection
    const ref = converter ? collectionFn(firestore, path).withConverter(converter) : collectionFn(firestore, path)

    const query = fQuery(
        ref,
        ...[
            ...(where ? where.map(w => fWhere(...w)) : []),
            ...(orderBy ? [fOrderBy(...orderBy)] : []),
            ...(limit ? [fLimit(limit)] : []),
            ...(startAfter ? [fStartAfter(startAfter)] : []),
        ],
    )
    const docs = await getDocs(query)
    return docs.docs
}
